import {createReducer} from '../../lib/Utils'
import * as actions from './actions'
import I18n from 'i18n-js'


const initialState = {
  queryParams: {},
  confirmPhoneUsername: null,
  user: null,
  error: null,
  isLoading: false,
  forgotPasswordConfirm: false,
  forgotPasswordByEmail: true,
  supportProposal: false,
  forgotPasswordPhoneNumber: null,
  forgotPasswordError: null,
  createRetailer: false,
  createUserConfirm: null,
  isCreateAccountFulfilled: false,
  resetPasswordRequired: null,
  resetRequiredPasswordEmail: null,
  resetPasswordByEmail: false,
  //Property for global spinner
  globalLoading: false,
  isNewApp: false,
  errorMessage: null,
  phoneError: false,
  emailError: false
}

export default createReducer(initialState, {
  [actions.SIGN_IN]: (state, action) => {
    return {
      ...state,
      emailError:false,
      errorMessage:null,
      isLoading: true,
      resetRequiredPasswordEmail: action.payload.email
    }
  },
  [actions.SIGN_IN_FULFILLED]: (state, action) => {
    return {
      ...state,
      user: action.payload,
      isLoading: false,
      error: null,
      resetRequiredPasswordEmail: null,
    }
  },
  [actions.SIGN_IN_REJECTED]: (state, action) => {
    return {
      ...state,
      user: action.payload,
      isLoading: false,
      globalLoading: false,
      resetRequiredPasswordEmail: null,
      error: action.payload.challengeName
        ? I18n.t(`errors.challenges.${action.payload.challengeName}`)
        : action.payload.message,
    }
  },
  [actions.CUSTOM_EMAIL_VERIFICATION]: (state, action) => {
    const {isNewApp} = action.payload;
    return {...state,
      isNewApp
    }
  },
  [actions.RESET_PASSWORD_REQUIRED]: (state) => {
    return {
      ...state,
      resetPasswordRequired: state.resetRequiredPasswordEmail,
    }
  },
  [actions.RESET_PASSWORD_NOT_REQUIRED]: (state) => {
    return {
      ...state,
      resetRequiredPasswordEmail: null,
      resetPasswordRequired: false,
    }
  },
  [actions.SET_CURRENT_USER]: (state, action) => {
    return {
      ...state,
      user: action.payload,
    }
  },
  [actions.COMPLETE_NEW_PASSWORD_REJECTED]: (state, action) => {
    return {
      ...state,
      error: action.payload.message,
    }
  },
  [actions.CREATE_ACCOUNT]: state => {
    return {
      ...state,
      isLoading: true,
      phoneError:false,
      emailError: false,
      errorMessage: null
    }
  },
  [actions.CREATE_ACCOUNT_FULFILLED]: (state, action) => {
    return {
      ...state,
      error: null,
      isCreateAccountFulfilled: true,
      isLoading: false,
      user_id: action.payload.user_id,
      user_email: action.payload.user_email,
      user_phone: action.payload.user_phone,
      user_first_name: action.payload.user_first_name,
      user_last_name: action.payload.user_last_name,
      createRetailer: (!action.payload.skipRetailer),
    }
  },
  [actions.CREATE_ACCOUNT_REJECTED]: (state, action) => {
    return {
      ...state,
      error: action.payload.message,
      isCreateAccountFulfilled: false,
      isLoading: false,
    }
  },
  [actions.HYDRATE_CURRENT_USER]: (state, action) => {
    return {
      ...state,
      user_id: action.payload['cognito:username'],
      user_email: action.payload.email,
      user_phone: action.payload.phone_number,
      user_first_name: action.payload.given_name,
      user_last_name: action.payload.family_name,
    }
  },
  [actions.MANUALLY_SET_JWT_FROM_COOKIE]: (state, action) => {
    return {
      ...state,
      user: {
        signInUserSession: {
          idToken: {
            jwtToken: action.payload
          }
        }
      }
    }
  },
  [actions.CONFIRM_PHONE_CODE]: state => {
    return {
      ...state,
      isLoading: true,
    }
  },
  [actions.CONFIRM_PHONE_CODE_FULFILLED]: (state, action) => {
    return {
      ...state,
      error: null,
      isLoading: false,
      createUserConfirm: action.payload,
      isCreateAccountFulfilled: true,
    }
  },
  [actions.CONFIRM_PHONE_CODE_REJECTED]: (state, action) => {
    return {
      ...state,
      isLoading: false,
      error: action.payload.message,
    }
  },
  [actions.RESET_PASSWORD]: state => {
    return {
      ...state,
      isLoading: true,
    }
  },
  [actions.RESET_PASSWORD_FULFILLED]: (state, action) => {
    return {
      ...state,
      resetPasswordByEmail: false,
      isLoading: false,
      forgotPasswordConfirm: true,
      forgotPasswordByEmail: false,
      forgotPasswordUsername: action.payload.phoneNumber,
      forgotPasswordError: null,
    }
  },
  [actions.RESET_PASSWORD_REJECTED]: (state, action) => {
    return {
      ...state,
      isLoading: false,
      forgotPasswordConfirm: false,
      forgotPasswordByEmail: true,
      forgotPasswordError: action.payload.message,
    }
  },
  [actions.CONFIRM_FORGOT_PASSWORD]: state => {
    return {
      ...state,
      isLoading: true,
    }
  },
  [actions.CONFIRM_FORGOT_PASSWORD_FULFILLED]: state => {
    return {
      ...state,
      isLoading: false,
      forgotPasswordConfirm: false,
      forgotPasswordByEmail: false,
      forgotPasswordError: null,
    }
  },
  [actions.CONFIRM_FORGOT_PASSWORD_REJECTED]: (state, action) => {
    return {
      ...state,
      globalLoading: false,
      isLoading: false,
      forgotPasswordError: action.payload.message,
    }
  },
  [actions.RESET_PASSWORD_BY_EMAIL]: state => {
    return {
      ...state,
      isLoading: true,
    }
  },
  [actions.RESET_PASSWORD_BY_EMAIL_FULFILLED]: (state, action) => {
    return {
      ...state,
      resetPasswordByEmail: true,
      isLoading: false,
      forgotPasswordConfirm: true,
      forgotPasswordUsername: action.payload.email,
      forgotPasswordByEmail: false,
      forgotPasswordError: null,
    }
  },
  [actions.RESET_PASSWORD_BY_EMAIL_REJECTED]: (state, action) => {
    return {
      ...state,
      isLoading: false,
      supportProposal: true,
      forgotPasswordConfirm: false,
      forgotPasswordByEmail: false,
      forgotPasswordError: action.payload.message,
    }
  },
  [actions.RESET_STATE]: state => {
    return {
      ...state,
      ...initialState,
      // Do not reset query params
      queryParams: state.queryParams,
    }
  },
  [actions.SET_URL_PARAMS_FULFILLED]: (state, action) => {
    return {
      ...state,
      queryParams: action.payload,
    }
  },
  [actions.CREATE_RETAILER]: state => {
    return {
      ...state,
      isLoading: true,
    }
  },
  [actions.CREATE_RETAILER_FULFILLED]: state => {
    return {
      ...state,
      err: null,
    }
  },
  [actions.CREATE_RETAILER_REJECTED]: state => {
    return {
      ...state,
      isLoading: false,
    }
  },
  [actions.SAVE_RETAILER_FULFILLED]: state => {
    return {
      ...state,
      isLoading: false
    }
  },
  [actions.SAVE_RETAILER_REJECTED]: state => {
    return {
      ...state,
      isLoading: false
    }
  },
  [actions.SET_SPINNER_ON]: state => {
    return {
      ...state,
      globalLoading: true
    }
  },
  [actions.LOGIN_ERROR]: (state,action) => {
    return{
      ...state,
      errorMessage: action.payload.errorMessage,
      phoneError: action.payload.phoneError,
      emailError: action.payload.emailError,
    }
  }
})
